import React, { useRef, useState, useEffect } from 'react';
import useId from '@indeed/ihl-use-id';

/* eslint no-void: ["error", { "allowAsStatement": true }]*/
const PopoverContext = /*#__PURE__*/React.createContext(undefined);
const PopoverProvider = PopoverContext.Provider;

/* eslint-disable @typescript-eslint/explicit-function-return-type */
const usePopover = _ref => {
  let {
    isMobile = false,
    dismissProps = {
      "aria-label": "Dismiss"
    },
    visible,
    onHide,
    onMount,
    ...tooltipProps
  } = _ref;
  const tippyRef = useRef();
  const triggerRef = useRef(null);
  const onDismiss = () => {
    if (tippyRef != null && tippyRef.current) {
      if (visible === undefined || onHide === undefined) {
        var _tippyRef$current;
        tippyRef == null || (_tippyRef$current = tippyRef.current) == null || _tippyRef$current.hide();
      } else {
        onHide(tippyRef == null ? void 0 : tippyRef.current);
      }
    }
  };
  const getTriggerProps = () => {
    return {
      ref: triggerRef
    };
  };
  const getCloseButtonProps = () => ({
    ...dismissProps,
    onClick: onDismiss
  });

  // hasTitle only becomes true once the usePopoverTitle hook is called by the PopoverTitle component
  const [hasTitle, setHasTitle] = useState(false);
  const titleIdGen = `ifl-PopoverTitle-${useId()}`;
  const titleId = hasTitle ? titleIdGen : undefined;
  const usePopoverTitle = () => {
    useEffect(() => {
      if (!hasTitle) {
        setHasTitle(true);
      }
    }, []);
    return titleIdGen;
  };
  const getTooltipProps = () => {
    return {
      onMount: tippy => {
        tippyRef.current = tippy;
        if (onMount) {
          onMount(tippy);
        }
      },
      visible,
      onHide,
      arrow: !isMobile,
      reference: triggerRef,
      trigger: visible !== undefined ? undefined : "click",
      ...tooltipProps
    };
  };
  return {
    isMobile,
    onDismiss,
    getTriggerProps,
    getCloseButtonProps,
    getTooltipProps,
    usePopoverTitle,
    titleId
  };
};
const usePopoverContext = () => {
  return React.useContext(PopoverContext);
};

export { PopoverProvider, usePopover, usePopoverContext };
